<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Executive </label>
                                    <multiselect
                                        v-model="GlobalEmployee"
                                        :options="employee_master"
                                        :allow-empty="true"
                                        open-direction="bottom"
                                        deselect-label="Can't remove this value"
                                        :custom-label="customLabel"
                                        track-by="EMPLOYEE_ID"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        aria-required="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Bank </label>
                                    <multiselect
                                        v-model="GlobalBank"
                                        :options="bank_master"
                                        :allow-empty="true"
                                        open-direction="bottom"
                                        deselect-label="Can't remove this value"
                                        track-by="BANK_ID"
                                        label="Bank_Name"
                                        @input="afterBankSelect"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        aria-required="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Branch Code</label>
                                    <multiselect
                                        v-model="GlobalBankBranch"
                                        :options="Bank_Branch_Master_For_Bank"
                                        :allow-empty="true"
                                        open-direction="bottom"
                                        deselect-label="Can't remove this value"
                                        track-by="BANK_BRACH_ID"
                                        label="Bank_Branch_Code"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        aria-required="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label> Product </label>
                                    <multiselect
                                        v-model="GlobalProduct"
                                        :options="Product_Master_For_Bank"
                                        :allow-empty="true"
                                        open-direction="bottom"
                                        deselect-label="Can't remove this value"
                                        track-by="PRODUCT_ID"
                                        label="Product_Name"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        aria-required="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Location</label>
                                    <multiselect
                                        v-model="Location"
                                        :options="Location_Master"
                                        :allow-empty="false"
                                        open-direction="bottom"
                                        :show-labels="false"
                                        deselect-label="Can't remove this value"
                                        aria-required="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Verify Start Date </label>
                                    <input type="date" v-model="startDate" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Verify End Date </label>
                                    <input type="date" v-model="endDate" />
                                </div>
                            </div>
                            <div
                                class="col-md-4"
                                v-if="
                                    userglobaldata.User_Status == 'SuperAdmin'
                                "
                            >
                                <div class="form-group">
                                    <label> Admins </label>
                                    <multiselect
                                        v-model="GlobalAdmin"
                                        :options="Admin_Master"
                                        :allow-empty="true"
                                        open-direction="bottom"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label="name"
                                        :show-labels="false"
                                        :close-on-select="true"
                                        aria-required="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-1 col-xs-2 column bt-column2">
                                <div class="form-group">
                                    <button
                                        class="btn btn-success"
                                        @click="
                                            loadAndSearchClientForOverAllCaseList(
                                                1
                                            )
                                        "
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">
                            Pending Case List Total:- {{ PendingTotalCount }}
                        </h3>

                        <div class="card-tools">
                            <button
                                type="button"
                                class="btn btn-danger"
                                :disabled="isPrinting"
                                @click="PrintData"
                            >
                                <span v-if="!isPrinting">
                                    <i class="fas fa-file-alt"></i> PDF
                                </span>
                                <span v-else>
                                    <i class="fas fa-spinner fa-spin"></i>
                                    Generating...
                                </span>
                            </button>

                            <vue-excel-xlsx
                                :data="Totaldata"
                                :columns="columns"
                                :filename="'Pending FI'"
                                :sheetname="'sheetname'"
                                class="btn btn-success"
                            >
                                Excel
                            </vue-excel-xlsx>
                            <input
                                class="btn search_box"
                                type="text"
                                placeholder="LoginId/Applicant"
                                @keyup="searchit"
                                v-model="search"
                                aria-label="Search"
                            />
                        </div>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                            <tr>
                                <th>Login Id</th>
                                <th>Bank Name</th>
                                <th>Branch Code</th>
                                <th>Product Name</th>
                                <th>Applicant Name</th>
                                <th>Executive</th>
                                <th>Location</th>
                                <th>Location Type</th>
                                <th>Address</th>
                                <th>Mobile Number</th>
                                <th>Created At</th>
                                <th>Allocated At</th>
                                <th>Verify At</th>
                                <th>Details</th>
                            </tr>
                            <tr
                                v-for="(client_master,
                                i) in client_masters.data"
                                :key="client_master.ECV_ID"
                                v-bind:id="i"
                            >
                                <td>
                                    {{ client_master.Login_Id
                                    }}{{
                                        tableColor(
                                            client_master.Verify_at,
                                            client_master.created_at,
                                            client_master.AssignDate,
                                            i
                                        )
                                    }}
                                </td>
                                <td>{{ client_master.Bank_Name }}</td>
                                <td>{{ client_master.Bank_Branch_Code }}</td>
                                <td>{{ client_master.Product_Name }}</td>
                                <td>{{ client_master.Applicant_Name }}</td>
                                <td
                                    v-if="
                                        client_master.Employee_First_Name !=
                                            null
                                    "
                                >
                                    {{ client_master.Employee_First_Name }}
                                    {{ client_master.Employee_Last_Name }} ({{
                                        client_master.Employee_User_Id
                                    }})
                                </td>
                                <td
                                    v-if="
                                        client_master.Employee_First_Name ==
                                            null
                                    "
                                >
                                    NULL
                                </td>
                                <td>{{ client_master.Location }}</td>
                                <td v-if="client_master.Location_Type != null">
                                    {{ client_master.Location_Type }}
                                </td>
                                <td v-if="client_master.Location_Type == null">
                                    NULL
                                </td>
                                <td v-if="client_master.Location_Type == 'RV'">
                                    {{ client_master.Residential_Address }}
                                </td>
                                <td
                                    v-else-if="
                                        client_master.Location_Type == 'BV'
                                    "
                                >
                                    {{ client_master.Office_Address }}
                                </td>
                                <td v-else>NULL</td>
                                <td v-if="client_master.Location_Type == 'RV'">
                                    {{
                                        client_master.Contact_Person_Mobile_Number
                                    }}
                                </td>
                                <td
                                    v-else-if="
                                        client_master.Location_Type == 'BV'
                                    "
                                >
                                    {{ client_master.Office_Mobile_Number }}
                                </td>
                                <td v-else>NULL</td>
                                <td>
                                    {{
                                        customDateFormatter(
                                            client_master.created_at
                                        )
                                    }}
                                </td>
                                <td>
                                    {{
                                        customDateFormatter(
                                            client_master.AssignDate
                                        )
                                    }}
                                </td>
                                <td>
                                    {{
                                        customDateFormatter(
                                            client_master.Verify_at
                                        )
                                    }}
                                </td>
                                <td v-if="client_master.BCP_ID == null">
                                    <a
                                        href="#"
                                        @click="ViewClientInfo(client_master)"
                                        ><i class="fas fa-info-circle red"></i
                                    ></a>
                                </td>
                                <td v-if="client_master.BCP_ID != null">
                                    <a
                                        href="#"
                                        @click="ViewClientInfo(client_master)"
                                        ><i class="fas fa-info-circle green"></i
                                    ></a>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                <pagination
                                    :data="client_masters"
                                    @pagination-change-page="
                                        loadAndSearchClientForOverAllCaseList
                                    "
                                    :limit="this.$PaginationCounterLimit"
                                >
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="
                                        loadAndSearchClientForOverAllCaseList(1)
                                    "
                                    aria-required="true"
                                >
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.card -->
            </div>
        </div>
        <!-- /.row -->
    </div>
</template>

<script>
import Toastselectedlet from "../widget/toast";
export default {
    props: ["userglobaldata"],
    components: { Multiselect, Toastselectedlet },
    data() {
        return {
            isPrinting: false,
            toast: new Vue(),
            GlobalAdmin: "",
            Admin_Master: [],
            Product_Master_For_Bank: [],
            Bank_Branch_Master_For_Bank: [],
            Location: null,
            Location_Master: ["local", "out"],
            search: "",
            startDate: "",
            endDate: "",
            GlobalProduct: "",
            GlobalEmployee: "",
            GlobalBank: "",
            GlobalBankBranch: "",
            bank_master: [],
            bank_branch_master: [],
            employee_master: [],
            product_master: [],
            Totaldata: [],
            client_masters: {},
            PendingTotalCount: "",
            columns: [
                {
                    label: "Login Id",
                    field: "Login_Id"
                },
                {
                    label: "Applicant Name",
                    field: "Applicant_Name"
                },
                {
                    label: "Bank Name",
                    field: "Bank_Name"
                },
                {
                    label: "Bank Branch Code",
                    field: "Bank_Branch_Code"
                },
                {
                    label: "Bank Branch Name",
                    field: "Bank_Branch_Name"
                },
                {
                    label: "Bank Branch Email",
                    field: "Bank_Branch_Email"
                },
                {
                    label: "Product Name",
                    field: "Product_Name"
                },
                {
                    label: "Executive First Name",
                    field: "Employee_First_Name"
                },
                {
                    label: "Executive Last Name",
                    field: "Employee_Last_Name"
                },
                {
                    label: "Executive User Id",
                    field: "Employee_User_Id"
                },
                {
                    label: "Location",
                    field: "Location"
                },
                {
                    label: "Location Type",
                    field: "Location_Type"
                },
                {
                    label: "Address",
                    field: "Address"
                },
                {
                    label: "Phone",
                    field: "Phone"
                },
                {
                    label: "Created At",
                    field: "created_at"
                },
                {
                    label: "Visit At",
                    field: "Visit_Date_Time"
                },
                {
                    label: "Verify At",
                    field: "Verify_at"
                }
            ]
        };
    },
    created() {
        Fire.$on("searching", () => {
            this.loadAndSearchClientForOverAllCaseList();
        });
        Fire.$on("AfterChangeClient", () => {
            this.loadAndSearchClientForOverAllCaseList();
        });
    },
    mounted() {
        this.loadEmployee();
        this.loadBank();
        this.loadAllProduct();
        this.loadBankBranch();
        this.loadAndSearchClientForOverAllCaseList();
        this.loadAdmins();
    },
    methods: {
        searchit: _.debounce(() => {
            Fire.$emit("searching");
        }, 500),
        tableColor(Verify_at, created_at, AssignDate, i) {
            console.log(i);
            if (Verify_at != null) {
                $("#" + i).addClass("table-success");
            } else if (AssignDate != null) {
                $("#" + i).addClass("table-danger");
            } else {
            }
        },
        afterselect_bank() {
            axios
                .get("/afterselect_bank/" + this.GlobalBank.BANK_ID)
                .then(({ data }) => {
                    this.Bank_Branch_Master_For_Bank = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        afterBankSelect() {
            this.afterselect_bank();
            axios
                .get("/loadProductBankWise/" + this.GlobalBank.BANK_ID)
                .then(({ data }) => {
                    this.Product_Master_For_Bank = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        customLabel(option) {
            return `${option.Employee_First_Name} ${option.Employee_Last_Name}(${option.Employee_User_Id})`;
        },
        ViewClientInfo(Data) {
            console.log("ViewClientInfo", Data)
            this.$router.push({
                name: "ClientInfo",
                params: { ClientInfo: Data }
            });
        },
        loadBankBranch() {
            axios
                .get("/loadBankBranch")
                .then(({ data }) => {
                    this.bank_branch_master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadAdmins() {
            axios
                .get("/loadAdmins")
                .then(({ data }) => {
                    this.Admin_Master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadEmployee() {
            axios
                .get("/loadEmployee")
                .then(({ data }) => {
                    this.employee_master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadBank() {
            axios
                .get("/loadBank")
                .then(({ data }) => {
                    this.bank_master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadAllProduct() {
            axios
                .get("/loadAllProduct")
                .then(({ data }) => {
                    this.product_master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadAndSearchClientForOverAllCaseList(page = 1) {
            var productid, bankid, employeeid, bankBranchId, AdminId, location;
            if (this.Location == null) {
                location = "undefined";
            } else {
                location = this.Location;
            }
            if (this.GlobalAdmin == null) {
                AdminId = "undefined";
            } else {
                AdminId = this.GlobalAdmin.id;
            }
            if (this.GlobalProduct == null) {
                productid = "undefined";
            } else {
                productid = this.GlobalProduct.PRODUCT_ID;
            }
            if (this.GlobalBank == null) {
                bankid = "undefined";
            } else {
                bankid = this.GlobalBank.BANK_ID;
            }
            if (this.GlobalEmployee == null) {
                employeeid = "undefined";
            } else {
                employeeid = this.GlobalEmployee.EMPLOYEE_ID;
            }
            if (this.GlobalBankBranch == null) {
                bankBranchId = "undefined";
            } else {
                bankBranchId = this.GlobalBankBranch.BANK_BRANCH_ID;
            }
            this.toast.$emit("ProgressBarLoading");
            axios
                .get(
                    "loadAndSearchClientForOverAllCaseList?query=" +
                        this.search +
                        "&bankBranchId=" +
                        bankBranchId +
                        "&location=" +
                        location +
                        "&adminId=" +
                        AdminId +
                        "&page=" +
                        page +
                        "&PaginationLimit=" +
                        this.$PaginationLimit +
                        "&startDate=" +
                        this.startDate +
                        "&endDate=" +
                        this.endDate +
                        "&bankId=" +
                        bankid +
                        "&productId=" +
                        productid +
                        "&employeeid=" +
                        employeeid
                )
                .then(({ data }) => {
                    (this.client_masters = data),
                        (this.PendingTotalCount = data.total),
                        this.exceldata();
                    this.toast.$emit("ProgressBarFinish");
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any Such User"
                    );
                });
        },
        exceldata() {
            var productid, bankid, employeeid, bankBranchId, AdminId, location;
            if (this.Location == null) {
                location = "undefined";
            } else {
                location = this.Location;
            }
            if (this.GlobalAdmin == null) {
                AdminId = "undefined";
            } else {
                AdminId = this.GlobalAdmin.id;
            }
            if (this.GlobalProduct == null) {
                productid = "undefined";
            } else {
                productid = this.GlobalProduct.PRODUCT_ID;
            }
            if (this.GlobalBank == null) {
                bankid = "undefined";
            } else {
                bankid = this.GlobalBank.BANK_ID;
            }
            if (this.GlobalEmployee == null) {
                employeeid = "undefined";
            } else {
                employeeid = this.GlobalEmployee.EMPLOYEE_ID;
            }
            if (this.GlobalBankBranch == null) {
                bankBranchId = "undefined";
            } else {
                bankBranchId = this.GlobalBankBranch.BANK_BRANCH_ID;
            }
            this.toast.$emit("ProgressBarLoading");
            axios
                .get(
                    "loadAndSearchClientForOverAllCaseListExcel?query=" +
                        this.search +
                        "&bankBranchId=" +
                        bankBranchId +
                        "&location=" +
                        location +
                        "&adminId=" +
                        AdminId +
                        "&PaginationLimit=" +
                        this.$PaginationLimit +
                        "&startDate=" +
                        this.startDate +
                        "&endDate=" +
                        this.endDate +
                        "&bankId=" +
                        bankid +
                        "&productId=" +
                        productid +
                        "&employeeid=" +
                        employeeid
                )
                .then(({ data }) => {
                    (this.Totaldata = data),
                        this.changeFormateForexcel(),
                        this.toast.$emit("ProgressBarFinish");
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFinish",
                        "Cannot Find Any Such User"
                    );
                });
        },
        changeFormateForexcel() {
            for (let i = 0; i < this.Totaldata.length; i++) {
                if (this.Totaldata[i].Location_Type == "RV") {
                    this.Totaldata[i].Address = this.Totaldata[
                        i
                    ].Residential_Address;
                    this.Totaldata[i].Phone = this.Totaldata[
                        i
                    ].Contact_Person_Mobile_Number;
                } else if (this.Totaldata[i].Location_Type == "BV") {
                    this.Totaldata[i].Address = this.Totaldata[
                        i
                    ].Office_Address;
                    this.Totaldata[i].Phone = this.Totaldata[
                        i
                    ].Office_Mobile_Number;
                }
            }
        },
        async PrintData() {
            if (this.isPrinting) return;
            if (!Array.isArray(this.Totaldata) || this.Totaldata.length === 0) {
                this.toast.$emit(
                    "ProgressBarFailerror",
                    "No records to export."
                );
                return;
            }
            this.isPrinting = true;
            this.toast.$emit("ProgressBarLoading");
            try {
                const response = await axios.post(
                    "/printData",
                    { data: this.Totaldata },
                    { responseType: "arraybuffer", validateStatus: () => true } // let us handle non-2xx gracefully
                );

                // ---- handle non-2xx and server-side error payloads ----
                const contentType = (
                    response.headers["content-type"] || ""
                ).toLowerCase();
                const isOk = response.status >= 200 && response.status < 300;

                // If server returned JSON/text (often error) while we asked for arraybuffer, try to decode it
                if (
                    !isOk ||
                    contentType.includes("application/json") ||
                    contentType.includes("text/plain") ||
                    contentType.includes("text/html")
                ) {
                    let serverMsg = `Request failed (${response.status})`;
                    try {
                        const decoded = new TextDecoder("utf-8").decode(
                            new Uint8Array(response.data)
                        );
                        // try JSON first; fall back to raw text/HTML snippet
                        serverMsg =
                            JSON.parse(decoded)?.message ||
                            decoded?.slice(0, 500);
                    } catch (_) {}
                    throw new Error(serverMsg || "Failed to generate file.");
                }

                // ---- success path: create blob and download ----
                const blob = new Blob([response.data], {
                    type: contentType || "application/zip"
                });

                // Prefer filename from Content-Disposition; fallback to default
                let fileName = "pdfFiles.zip";
                const cd = response.headers["content-disposition"];
                if (cd) {
                    const match = /filename\*?=(?:UTF-8'')?["']?([^\"';]+)["';]?/i.exec(
                        cd
                    );
                    if (match && match[1])
                        fileName = decodeURIComponent(match[1]);
                }

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                setTimeout(() => URL.revokeObjectURL(url), 0);

                this.toast.$emit("ProgressBarFinish");
            } catch (err) {
                // Show a clean, user-friendly error
                const msg =
                    err && err.message
                        ? err.message
                        : "Cannot generate ZIP. Please try again.";
                this.toast.$emit("ProgressBarFailerror", msg);
            } finally {
                this.isPrinting = false;
            }
        }
    }
};
</script>
